module.exports = __webpack_public_path__ + "img/bw.b62a5cde.svg";